// frontend/src/config/achievements.ts

import { GameStats } from '../services/games/gameStatsService';

/** Bir round bittiğinde, o round'a özel gerçekleri taşıyan serbest form bağlam. */
export type AchievementSessionContext = Record<string, number | boolean | undefined>;

export interface AchievementDefinition {
  /** Global olarak benzersiz id. */
  id: string;
  gameId: string;
  title: string;
  description: string;
  icon: string;
  /** stats: bu session kaydedildikten SONRAKİ kümülatif istatistikler. session: bu round'a özel gerçekler. */
  check: (stats: GameStats, session: AchievementSessionContext) => boolean;
}

export const ACHIEVEMENTS: AchievementDefinition[] = [
  // ── Snake ──────────────────────────────────────────────
  {
    id: 'snake-first-fruit',
    gameId: 'snake',
    title: 'İlk Meyve',
    description: 'İlk meyveni ye.',
    icon: '🍎',
    check: (stats) => (stats.cumulative.fruitsEaten ?? 0) >= 1,
  },
  {
    id: 'snake-100-fruits',
    gameId: 'snake',
    title: '100 Meyve',
    description: 'Toplamda 100 meyve ye.',
    icon: '🍇',
    check: (stats) => (stats.cumulative.fruitsEaten ?? 0) >= 100,
  },
  {
    id: 'snake-1000-score',
    gameId: 'snake',
    title: '1000 Skor',
    description: 'Tek oyunda 1000 skora ulaş.',
    icon: '🏆',
    check: (stats) => stats.highScore >= 1000,
  },

  // ── Memory ─────────────────────────────────────────────
  {
    id: 'memory-first-match',
    gameId: 'memory',
    title: 'İlk Eşleşme',
    description: 'İlk hafıza oyununu tamamla.',
    icon: '🧠',
    check: (stats) => stats.gamesPlayed >= 1,
  },
  {
    id: 'memory-perfect-game',
    gameId: 'memory',
    title: 'Kusursuz Oyun',
    description: 'Hiç yanlış çevirmeden bir oyunu bitir.',
    icon: '✨',
    check: (_stats, session) => session.isPerfect === true,
  },
  {
    id: 'memory-fast-finish',
    gameId: 'memory',
    title: 'Hızlı Bitiriş',
    description: 'Bir oyunu 30 saniyenin altında bitir.',
    icon: '⚡',
    check: (_stats, session) => typeof session.durationMs === 'number' && session.durationMs < 30_000,
  },

  // ── Sudoku ─────────────────────────────────────────────
  {
    id: 'sudoku-first-puzzle',
    gameId: 'sudoku',
    title: 'İlk Bulmaca',
    description: 'İlk sudokunu tamamla.',
    icon: '🧩',
    check: (stats) => (stats.cumulative.puzzlesCompleted ?? 0) >= 1,
  },
  {
    id: 'sudoku-25-puzzles',
    gameId: 'sudoku',
    title: '25 Bulmaca',
    description: '25 sudoku tamamla.',
    icon: '📘',
    check: (stats) => (stats.cumulative.puzzlesCompleted ?? 0) >= 25,
  },
  {
    id: 'sudoku-100-puzzles',
    gameId: 'sudoku',
    title: '100 Bulmaca',
    description: '100 sudoku tamamla.',
    icon: '📚',
    check: (stats) => (stats.cumulative.puzzlesCompleted ?? 0) >= 100,
  },

  // ── Tetris ─────────────────────────────────────────────
  {
    id: 'tetris-first-line',
    gameId: 'tetris',
    title: 'İlk Satır',
    description: 'İlk satırını temizle.',
    icon: '🧱',
    check: (stats) => (stats.cumulative.linesCleared ?? 0) >= 1,
  },
  {
    id: 'tetris-50-lines',
    gameId: 'tetris',
    title: '50 Satır',
    description: 'Toplamda 50 satır temizle.',
    icon: '🏗️',
    check: (stats) => (stats.cumulative.linesCleared ?? 0) >= 50,
  },
  {
    id: 'tetris-5000-score',
    gameId: 'tetris',
    title: '5000 Skor',
    description: 'Tek oyunda 5000 skora ulaş.',
    icon: '🌟',
    check: (stats) => stats.highScore >= 5000,
  },

  // ── Tic Tac Toe ────────────────────────────────────────
  {
    id: 'ttt-first-win',
    gameId: 'tic-tac-toe',
    title: 'İlk Galibiyet',
    description: 'İlk oyununu kazan.',
    icon: '❌',
    check: (stats) => (stats.cumulative.wins ?? 0) >= 1,
  },
  {
    id: 'ttt-10-wins',
    gameId: 'tic-tac-toe',
    title: '10 Galibiyet',
    description: '10 oyun kazan.',
    icon: '🏅',
    check: (stats) => (stats.cumulative.wins ?? 0) >= 10,
  },
];
